const haveVisaScores = [
    { min: 0, max: 27, haveVisa: true, score: 10 },
    { min: 27, max: 40, haveVisa: true, score: 14 },
    { min: 40, max: 55, haveVisa: true, score: 20 },
    { min: 55, max: 200, haveVisa: true, score: 30 }
];

export default haveVisaScores;
